module.exports = __webpack_public_path__ + "img/polling.9a77c6b9.png";